import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PieChartFour } from "../../../../Constant";
import { PIE_FOUR_CHART_DATA, PIE_FOUR_CHART_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const PieChart4 = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={PieChartFour} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="pie-chart2">
            <Chart chartType="PieChart" width="100%" height="300px" data={PIE_FOUR_CHART_DATA} options={PIE_FOUR_CHART_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PieChart4;
